import React, { useState, useCallback } from "react";

export default function SideNav() {
  const [active, setActive] = useState<any>();

  const scrollto = useCallback((id: any) => {
    var scrollDiv = document.getElementById(id)!;
    window.scrollTo({ top: scrollDiv?.offsetTop - 52, behavior: 'smooth'});
    setActive(id)
  }, [])
    return(
        <div className="sidenav">
        <div className={`${active === "gettingStarted" ? "activeClr" : ""} gettingStarted`}  onClick={()=>scrollto("gettingStarted")}>
            Getting Started
          </div>
          <div className="sidenavHeader" onClick={()=>scrollto("basicUsage")}>Basic Usage</div>
          <div className="subMenu">
            <div className={active === "singleSelect" ? "activeClr" : ""} onClick={()=>scrollto("singleSelect")}>Single Select</div>
            <div className={active === "multiSelect" ? "activeClr" : ""} onClick={()=>scrollto("multiSelect")} >Multiple Select</div>
            <div className={active === "rangeSelect" ? "activeClr" : ""} onClick={()=>scrollto("rangeSelect")} >Range Select</div>
          </div>
          <div className="sidenavHeader" onClick={()=>scrollto("slotBooking")} >Slot Booking</div>
          <div className="subMenu">
            <div className={active === "singleSlotBooking" ? "activeClr" : ""} onClick={()=>scrollto("singleSlotBooking")} >Single Slot Booking</div>
            <div className={active === "duelSlotBooking" ? "activeClr" : ""} onClick={()=>scrollto("duelSlotBooking")} >Duel Slots Booking</div>
          </div>
          <div className="sidenavHeader" onClick={()=>scrollto("disableDates")} >Disable Dates</div>
          <div className="subMenu">
            <div className={active === "minAndmax" ? "activeClr" : ""} onClick={()=>scrollto("minAndmax")} >MinDate and MaxDate</div>
            <div className={active === "disableSpecific" ? "activeClr" : ""} onClick={()=>scrollto("disableSpecific")} >Disable Specific Dates and Disable Days</div>
          </div>
          <div className="sidenavHeader" onClick={()=>scrollto("customization")} >Customization</div>
          <div className="subMenu">
            <div className={active === "dropDown" ? "activeClr" : ""} onClick={()=>scrollto("dropDown")} >Dropdown</div>
            <div className={active === "overrideCss" ? "activeClr" : ""} onClick={()=>scrollto("overrideCss")} >Override CSS</div>
            <div className={active === "propsFlow" ? "activeClr" : ""} onClick={()=>scrollto("propsFlow")} >Props Flow</div>
          </div>
        </div>
    )
}